"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _withPauseAndHelpLogic = _interopRequireDefault(require("../higherOrderComponents/withPauseAndHelpLogic"));

var _loadPlayerApi = require("ui-addon-video-player/utils/loadPlayerApi");

function generateRandomString() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

var ONPLAY_TIMEOUT = 500;

var VidyardVideoPlayer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(VidyardVideoPlayer, _Component);

  function VidyardVideoPlayer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, VidyardVideoPlayer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(VidyardVideoPlayer).call(this, props));
    _this.uniqueId = "ui-addon-video-player-container-" + generateRandomString();
    _this.state = {
      hasMarkedProgress: false,
      onPlayTimeout: undefined
    };
    _this.bindVideoEvents = _this.bindVideoEvents.bind((0, _assertThisInitialized2.default)(_this));
    _this.getVidyardPlayer = _this.getVidyardPlayer.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleVideoPlay = _this.handleVideoPlay.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(VidyardVideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (window.vidyardEmbed) {
        this.setupVideoPlayer(this.props.videoId);
      } else {
        (0, _loadPlayerApi.loadVidyardApi)(function () {
          _this2.setupVideoPlayer(_this2.props.videoId);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.videoId !== this.props.videoId && window.vidyardEmbed) {
        prevProps.cancelHelpTextTimeout();
        var oldPlayer = this.getVidyardPlayer(prevProps);

        if (oldPlayer) {
          // There isn't a method on the Vidyard API to replace the video in a player with another,
          // so for now we just have to tear down the player nad set up a new one.
          window.vidyardEmbed.api.destroyPlayer(oldPlayer);
          prevProps.onChangeVideo();
        }

        this.setState({
          hasMarkedProgress: false
        });
        this.setupVideoPlayer(this.props.videoId);
      } else if (prevProps.videoPlaySpeed !== this.props.videoPlaySpeed) {
        var player = this.getVidyardPlayer();

        if (player) {
          player.setPlaybackSpeed(this.props.videoPlaySpeed / 100);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var maybePlayer = this.getVidyardPlayer();

      if (maybePlayer) {
        window.vidyardEmbed.api.destroyPlayer(maybePlayer);
      }
    }
  }, {
    key: "setupVideoPlayer",
    value: function setupVideoPlayer(uuid) {
      var _this3 = this;

      var _this$props = this.props,
          captionsOnByDefault = _this$props.captionsOnByDefault,
          onReady = _this$props.onReady,
          enableEmbed = _this$props.enableEmbed,
          enableSharing = _this$props.enableSharing,
          color = _this$props.color;
      this.props.startHelpTextTimeout();
      var playerPromise = window.vidyardEmbed.api.renderPlayer((0, _extends2.default)({
        color: color.indexOf('#') === 0 ? color.substr(1) : color,
        container: document.getElementById(this.uniqueId),
        embed_button: enableSharing ? 1 : 0,
        uuid: uuid,
        viral_sharing: enableEmbed ? 1 : 0
      }, this.getOptionsFromProps()));
      playerPromise.then(function (player) {
        _this3.props.cancelHelpTextTimeout();

        _this3.bindVideoEvents(player);

        if (captionsOnByDefault) {
          player.enableCaption();
        }

        if (onReady) {
          _this3.props.onReady();
        }
      });
    }
  }, {
    key: "getVidyardPlayer",
    value: function getVidyardPlayer() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var videoId = props.videoId;

      if (window.VidyardV4) {
        var players = window.VidyardV4.api.getPlayersByUUID(videoId);
        return players[0];
      }

      return undefined;
    }
  }, {
    key: "getOptionsFromProps",
    value: function getOptionsFromProps() {
      var _this$props2 = this.props,
          color = _this$props2.color,
          autoPlay = _this$props2.autoPlay,
          videoPlaySpeed = _this$props2.videoPlaySpeed;
      return {
        autoplay: autoPlay ? '1' : '0',
        play_button_color: color && color.replace('#', ''),
        speed: videoPlaySpeed / 100
      };
    }
  }, {
    key: "handleVideoPlay",
    value: function handleVideoPlay() {
      var _this4 = this;

      // The first video play video play on an instance of a Vidyard player
      // causes the `onPlay` handler to be fired twice in very quick succession.
      // I'm going to debounce the onPlay here.
      if (!this.state.onPlayTimeout) {
        this.setState({
          onPlayTimeout: setTimeout(function () {
            _this4.props.onPlay();

            _this4.setState({
              onPlayTimeout: undefined
            });
          }, ONPLAY_TIMEOUT)
        });
      }
    }
  }, {
    key: "bindVideoEvents",
    value: function bindVideoEvents(player) {
      var _this5 = this;

      var _this$props3 = this.props,
          onPlay = _this$props3.onPlay,
          onFinish = _this$props3.onFinish,
          onPause = _this$props3.onPause,
          onUpdateProgress = _this$props3.onUpdateProgress;

      if (onPlay) {
        player.on('play', this.handleVideoPlay);
      }

      if (onPause) {
        player.on('pause', onPause);
      }

      if (onFinish) {
        player.on('playerComplete', onFinish);
      }

      if (onUpdateProgress) {
        player.on('timeupdate', function (seconds) {
          if (!_this5.state.hasMarkedProgress && seconds > 10) {
            _this5.setState({
              hasMarkedProgress: true
            });

            onUpdateProgress();
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: this.uniqueId
      });
    }
  }]);
  return VidyardVideoPlayer;
}(_react.Component);

VidyardVideoPlayer.propTypes = {
  autoPlay: _propTypes.default.bool,
  cancelHelpTextTimeout: _propTypes.default.func.isRequired,
  captionsOnByDefault: _propTypes.default.bool,
  color: _propTypes.default.string,
  enableEmbed: _propTypes.default.bool,
  enableSharing: _propTypes.default.bool,
  onFinish: _propTypes.default.func,
  onPause: _propTypes.default.func,
  onPlay: _propTypes.default.func,
  onReady: _propTypes.default.func,
  onChangeVideo: _propTypes.default.func,
  onUpdateProgress: _propTypes.default.func,
  startHelpTextTimeout: _propTypes.default.func.isRequired,
  videoId: _propTypes.default.string.isRequired,
  videoPlaySpeed: _propTypes.default.number
};

var _default = (0, _withPauseAndHelpLogic.default)(VidyardVideoPlayer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-video-player/static-1.2019/js/components/VidyardVideoPlayer.js
// module id = 274
// module chunks = 0